var _g, _defs;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgArrowLine = function SvgArrowLine(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 131,
    viewBox: "0 0 41 131",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7327 130.164C0.641126 102.392 -13.3058 52.989 15.8948 5.28403",
    stroke: "#192D6D",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1269 3.03351C13.0519 3.05649 12.973 3.06378 12.895 3.05494C12.817 3.0461 12.7417 3.02131 12.6737 2.98212C12.6058 2.94292 12.5466 2.89016 12.4999 2.82711C12.4531 2.76406 12.4199 2.69208 12.4022 2.61563C12.3651 2.45676 12.3898 2.28973 12.4712 2.14838C12.5527 2.00702 12.6848 1.90191 12.8409 1.85434L18.4901 0.193795C18.6151 0.155475 18.7466 0.143289 18.8766 0.157999C19.0065 0.17271 19.132 0.213999 19.2453 0.2793C19.3586 0.344601 19.4572 0.432518 19.535 0.537576C19.6129 0.642634 19.6683 0.762588 19.6978 0.889974L21.0832 6.61342C21.12 6.77225 21.0951 6.93915 21.0136 7.08033C20.932 7.22152 20.7999 7.32645 20.6439 7.3739C20.5689 7.39687 20.4899 7.40417 20.412 7.39533C20.334 7.38649 20.2587 7.3617 20.1907 7.32251C20.1227 7.28331 20.0635 7.23055 20.0168 7.1675C19.9701 7.10445 19.9369 7.03247 19.9192 6.95603L18.5816 1.42984L13.1269 3.03351V3.03351Z",
    fill: "#1D2E69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 131,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-line.4596499b.svg";
export { ForwardRef as ReactComponent };